import { render, staticRenderFns } from "./ClientesNuevos.vue?vue&type=template&id=4d801c6d&scoped=true"
import script from "./ClientesNuevos.vue?vue&type=script&lang=js"
export * from "./ClientesNuevos.vue?vue&type=script&lang=js"
import style0 from "./ClientesNuevos.vue?vue&type=style&index=0&id=4d801c6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d801c6d",
  null
  
)

export default component.exports